import React, { Component } from "react";
import { DropdownButton, MenuItem } from "react-bootstrap";
import get from "lodash/get";
import { classNames } from "react-extras";
import "./context_menu.scss";
import icon from "../../../icons/ellipses-icon.svg";

class ContextMenu extends Component {
  constructor(props) {
    super(props);
    this.ref = React.createRef();
  }

  state = {
    pullRight: false,
  };

  componentDidMount() {
    this.setRightLeft();
  }

  setRightLeft = e => {
    if (e) {
      e.preventDefault();
    }
    var current = get(this.ref, "current");
    if (!current) {
      this.setState({ pullRight: false });
      return;
    }

    const pullRight =
      this.props.pullRight !== undefined
        ? this.props.pullRight
        : current.getBoundingClientRect().left > window.innerWidth / 2;
    this.setState({ pullRight });
  };

  render() {
    return (
      <span
        className={classNames(
          "seedcast-context-menu-wrapper",
          this.props.noCircle && "seedcast-context-menu-wrapper--no-circle",
          this.props.className
        )}
        ref={this.ref}>
        <DropdownButton
          className="seedcast-context-menu"
          id={this.props.text || "context-menu" + Math.floor(Math.random() * 1000)}
          noCaret
          title={
            this.props.text || <img src={icon} className="context-menu__ellipsis" alt="menu" />
          }
          pullRight={this.state.pullRight}
          dropup={this.props.dropUp}
          onClick={this.setRightLeft}>
          {Object.keys(this.props.menuItems).map(title => {
            return (
              <MenuItem key={title} onSelect={this.props.menuItems[title]} className="subtext">
                {title}
              </MenuItem>
            );
          })}
        </DropdownButton>
      </span>
    );
  }
}
export default ContextMenu;
